import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core'
import { AddressDB } from '../../../user-management/models/address'
import * as _ from 'lodash'
import { PhoneNumberInputMask } from '../../../common/input-masks/phone-number.input-mask'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { UserPhone } from '../../models/user-phone'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { StateGateway } from '../../../common/gateways/state-gateway'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    templateUrl: 'dual-address.component.html',
    selector: 'DualAddress'
})
export class DualAddressComponent implements OnInit {
    @Input() topAddress: AddressDB = {} as AddressDB
    @Input() bottomAddress: AddressDB = {} as AddressDB
    @Input() phone: UserPhone = {} as UserPhone
    @Input() cellPhone: UserPhone = {} as UserPhone
    @Input() states: State[] = [] as State[]
    @Input() LTCFacilityName: string = ''
    @Input() LTCFacilityPhone: string = ''
    @Input() isPOBox: boolean
    @Input() isExternalAgentEnrl: boolean

    @Output() onTopAddressChange: EventEmitter<AddressDB> = new EventEmitter<AddressDB>()
    @Output() onBottomAddressChange: EventEmitter<AddressDB> = new EventEmitter<AddressDB>()
    @Output() onLTCFacilityNameChange: EventEmitter<string> = new EventEmitter<string>()
    @Output() onLTCFacilltyPhoneChange: EventEmitter<string> = new EventEmitter<string>()
    @Output() onValueChange = new EventEmitter<boolean>()

    @Input() poBox = true
    @Input() topAddressLinePrefix = ''
    @Input() bottomAddressLinePrefix = ''
    @Input() topAddressName = ''
    @Input() bottomAddressName = ''
    @Input() showPhone = false
    @Input() showCellPhone = false
    @Input() disabled = false
    @Input() allowPOBoxes = true
    @Input() checked: boolean
    allStates: State[] = [] as State[]
    phoneNumberInputMask = new PhoneNumberInputMask()
    lengthValidator = new LengthTextFieldValidator(10)
    numericValidator = new NumericTextFieldValidator()
    notBlankValidator = new NotBlankGenericFieldValidator()

    sameAstopAddress = false
    visibleFrom2026: boolean
    constructor(private _stateGateway: StateGateway, public _global: PortalGlobals) {
        this._stateGateway.getAllStates().subscribe((states: State[]) => {
            this.allStates = states
            this.allStates.unshift({ value: 0, text: '-- Choose One --' })
            if (this.allowPOBoxes === true)
                _.remove(this.allStates, function (stat) {
                    return stat.value === 'VI' || stat.value === 'PR'
                })
        })

        if (this._global.selectedPlanYear >= this._global.Planyear2026) {
            this.visibleFrom2026 = true;
        }
    }

    ngOnInit(): void {
        //const poBox = JSON.parse(localStorage.getItem('isPOBox') || 'false');
        if (this.topAddress.sameAddress) {
            this.sameAstopAddress = true
        } else {
            this.sameAstopAddress = false
        }

        //if (poBox)
        //    this.isPOBox = true
        //else
        //    this.isPOBox=false
    }
    getValue(): boolean {
        return this.checked
    }

    clickOnSameAsTopAddress() {
        this.topAddress.sameAddress = !this.topAddress.sameAddress
        if (this.topAddress.sameAddress) {
            // this.sameAstopAddress = true
            this.topAddress.sameAddress = true
            this.onBottomAddressChange.emit(_.clone(this.topAddress))
        } else {
            // this.sameAstopAddress = false
            this.bottomAddress.sameAddress = false
            this.clearbottomAddress()
            this.onBottomAddressChange.emit(this.bottomAddress)
        }
    }

    clearbottomAddress() {
        this.bottomAddress.city = ''
        this.bottomAddress.addressLine1 = ''
        this.bottomAddress.addressLine2 = ''
        this.bottomAddress.zip = ''
        this.bottomAddress.zip4 = ''
        this.bottomAddress.state = ''
    }

    updateTopAddress(newTopAddress: AddressDB) {
        this.onTopAddressChange.emit(_.clone(newTopAddress))
        if (newTopAddress.sameAddress) {
            this.onBottomAddressChange.emit(_.clone(newTopAddress))
        }
    }
    onPOBoxChecked(newValue: boolean)
    {  
        this.checked = newValue; 
        this.onValueChange.emit(newValue);
    }
}
